import { Box, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

const MessagesSidebar = ({ messages, selectedMessageId, onSelectMessage = () => {} }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: 320,
        flexShrink: 0,
        backgroundColor: theme.palette.primary.white,
        borderRight: `1px solid ${theme.palette.primary.borderGreyPrimary}`,
        padding: '8px 0',
      }}
    >
      {messages.map(message => {
        const isSelected = message.id === selectedMessageId;

        return (
          <Box
            key={message.id}
            onClick={() => onSelectMessage(message.id)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              margin: '2px 10px 10px 10px',
              padding: '10px',
              cursor: 'pointer',
              border: `1px solid ${theme.palette.primary.borderGreyPrimary}`,
              backgroundColor: isSelected ? theme.palette.primary.subBlue : 'transparent',
              '&:hover': {
                backgroundColor: theme.palette.primary.lightBlue,
              },
            }}
          >
            <IconButton
              size="small"
              disableRipple
              sx={{
                padding: 0,
                color: message.visible ? theme.palette.primary.greyPrimary : theme.palette.primary.greyThird,
              }}
            >
              {message.visible ? <VisibilityOutlinedIcon sx={{ fontSize: 18 }} /> : <VisibilityOffOutlinedIcon sx={{ fontSize: 18 }} />}
            </IconButton>
            <Typography
              sx={{
                fontSize: theme.typography.customFontSize[1],
                color: isSelected ? theme.palette.primary.greyPrimary : theme.palette.primary.greySecound,
                lineHeight: 1.4,
              }}
            >
              {message.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default MessagesSidebar;
